import http from '@services/http'

export default {
  login(data: object): Promise<any> {
    return http.post('user-api/user/login', data || {})
  },

  jaLogin(data: object): Promise<any> {
    return http.post('editor-api/login', data || {})
  },

  jaLogout(data?: object): Promise<any> {
    return http.post('editor-api/logout', data || {})
  },

  logout(data?: object): Promise<any> {
    return http.post('user-api/user/logout', data || {})
  },
  authEmail(data: object): Promise<any> {
    console.log('authEmail', data)

    return http.post('user-api/user/register/authEmail', data || {})
  },
  lostPassword(data: object): Promise<any> {
    console.log('authEmail', data)
    return http.post('user-api/user/resetPwd//authEmail', data || {})
  },
  checkResetPwdToken(data: object): Promise<any> {
    console.log('checkResetPwdToken', data)
    return http.post('user-api/user/resetPwd/checkToken', data || {})
  },
  checkToken(data: object): Promise<any> {
    console.log('checkToken', data)
    return http.post('user-api/user/register/checkToken', data || {})
  },
  registerUser(data: object): Promise<any> {
    console.log('registerUser', data)

    return http.post('user-api/user/register', data || {})
  },
  resetPwd(data: object): Promise<any> {
    console.log('registerUser', data)
    return http.post('user-api/user/resetPwd', data || {})
  }
}
